export default __webpack_public_path__ + "static/media/trusted-by-dupont.7341c15f.png";